<cdk-accordion class="flex flex-col gap-6">
    <cdk-accordion-item #openingHours="cdkAccordionItem" class="mt-8">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="openingHours.toggle()" [attr.aria-expanded]="openingHours.expanded">
                <span>Öffnungszeiten</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="openingHours.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (openingHours.expanded) {
                <div class="p-6 border-b border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm">
                        <div formArrayName="consultingHours"
                             class="consulting-hours justify-center flex flex-col items-center">
                            <!-- Loop over each consulting hour -->
                            @for (hour of consultingHours.controls; track hour; let i = $index) {
                                <div
                                    [formGroupName]="i"
                                    class="grid grid-cols-1 md:grid-cols-12 gap-4 items-end bg-app-background-20/30 p-4 rounded-lg border border-app-primary-10/5">
                                    <div class="md:col-span-4 flex flex-col gap-2">
                                        <label class="text-sm font-medium">Tag</label>
                                        <mat-select formControlName="day" class="custom-select">
                                            <mat-option [value]="'Montag'">Montag</mat-option>
                                            <mat-option [value]="'Dienstag'">Dienstag</mat-option>
                                            <mat-option [value]="'Mittwoch'">Mittwoch</mat-option>
                                            <mat-option [value]="'Donnerstag'">Donnerstag</mat-option>
                                            <mat-option [value]="'Freitag'">Freitag</mat-option>
                                            <mat-option [value]="'Samstag'">Samstag</mat-option>
                                            <mat-option [value]="'Sonntag'">Sonntag</mat-option>
                                        </mat-select>
                                    </div>
                                    <div class="md:col-span-3 flex flex-col gap-2">
                                        <label class="text-sm font-medium">Von</label>
                                        <input matInput type="time" formControlName="from">
                                    </div>
                                    <div class="md:col-span-3 flex flex-col gap-2">
                                        <label class="text-sm font-medium">Bis</label>
                                        <input matInput type="time" formControlName="to">
                                    </div>
                                    <div class="md:col-span-2 flex justify-end">
                                        <button
                                            class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                            (click)="removeConsultingHour(i)">
                                            <i class="fa-solid fa-times icon-center"></i>
                                        </button>
                                    </div>
                                </div>
                            }
                            <div class="flex justify-end w-full gap-6">
                                <button class="btn primary-button"
                                        (click)="triggerNewConsultingHour()">
                                    Öffnungszeiten hinzufügen
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            }
        </div>
    </cdk-accordion-item>

    <cdk-accordion-item #timeSlot="cdkAccordionItem">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="timeSlot.toggle()" [attr.aria-expanded]="timeSlot.expanded">
                <span>Terminlänge</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="timeSlot.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (timeSlot.expanded) {
                <div class="p-6 border-b border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm">
                        <div class="form-group">
                            <div class="form-control">
                                <label>Terminlange</label>
                                <input matInput type="number" formControlName="consultantDurationInMinutes">
                            </div>
                            <div class="form-control">
                                <label>Wie lange darf ein Termin im voraus gebucht werden ? ( in Wochen )</label>
                                <input matInput type="number"
                                       formControlName="appointmentMaxToInWeeks">
                            </div>
                        </div>
                    </form>
                </div>
            }
        </div>
    </cdk-accordion-item>

    <cdk-accordion-item #costs="cdkAccordionItem">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="costs.toggle()" [attr.aria-expanded]="costs.expanded">
                <span>Kosten</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="costs.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (costs.expanded) {
                <div class="p-6 border-b border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm">
                        <div class="form-group">
                            <div class="form-control">
                                <label>Behandlungskosten in €</label>
                                <input matInput type="number" formControlName="treatmentCosts">
                            </div>
                            <div class="form-control">
                                <label>Rezeptkosten in €</label>
                                <input matInput type="number" formControlName="prescriptionCosts">
                            </div>
                            <div class="form-control">
                                <label>Versandkosten in €</label>
                                <input matInput type="number" formControlName="shippingCostsForPrescription">
                            </div>
                            <div class="form-control">
                                <label>Aliacura Nutzungsgebühr in €</label>
                                <input matInput type="number" formControlName="aliacuraPortalFees">
                            </div>
                            <div class="form-control">
                                <label>Aliacura Versandgebühr in €</label>
                                <input matInput type="number" formControlName="aliacuraPostage">
                            </div>
                            <div class="form-control">
                                <label>Aliacura Abholungsgebühr in €</label>
                                <input matInput type="number" formControlName="aliacuraDebtCollectionFees">
                            </div>
                        </div>
                    </form>
                </div>
            }
        </div>
    </cdk-accordion-item>

    <cdk-accordion-item #vacationPlanning="cdkAccordionItem">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="vacationPlanning.toggle()" [attr.aria-expanded]="vacationPlanning.expanded">
                <span>Urlaubsplanung</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="vacationPlanning.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (vacationPlanning.expanded) {
                <div class="p-6 border-b border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm">
                        <div formArrayName="holidays"
                             class="consulting-hours justify-center flex flex-col items-center">
                            <!-- Loop over each holiday -->
                            @for (holiday of holidays.controls; track holiday; let i = $index) {
                                <div
                                    class="form-group w-full border-b border-canna-primary pb-4">
                                    <div class="form-control">
                                        <label>Urlaubszeit</label>
                                        <div class="flex gap-4">
                                            <div class="datepicker-range">
                                                <mat-date-range-input [rangePicker]="picker" [formGroupName]="i">
                                                    <input matStartDate formControlName="from"
                                                           placeholder="Urlaubsbeginn">
                                                    <input matEndDate formControlName="to"
                                                           placeholder="Urlaubsbeginn">
                                                </mat-date-range-input>
                                                <mat-datepicker-toggle matIconSuffix
                                                                       [for]="picker"></mat-datepicker-toggle>
                                                <mat-date-range-picker
                                                    #picker="matDateRangePicker"></mat-date-range-picker>
                                            </div>
                                            <button
                                                class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                                (click)="removeHoliday(i)">
                                                <i class="fa-solid fa-times icon-center"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div class="flex justify-end w-full mt-4gap-6">
                                <button class="btn primary-button"
                                        (click)="triggerNewHoliday()">
                                    Urlaub hinzufügen
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            }
        </div>
    </cdk-accordion-item>

    <cdk-accordion-item #customEmailText="cdkAccordionItem">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="customEmailText.toggle()" [attr.aria-expanded]="customEmailText.expanded">
                <span>Standard Text für E-Mails</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="customEmailText.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (customEmailText.expanded) {
                <div class="p-6 border-b border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm">
                        <div class="form-group">
                            <div class="form-control">
                                <label>Standard Text für Emails</label>
                                <textarea matInput formControlName="customTextForEmail" rows="6"
                                          class="min-h-[100px]"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
            }
        </div>
    </cdk-accordion-item>

    <cdk-accordion-item #stamp="cdkAccordionItem">
        <div
            class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden">
            <button
                class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-xl hover:bg-gray-50 transition-colors"
                (click)="stamp.toggle(); loadSignatureToPad()" [attr.aria-expanded]="stamp.expanded">
                <span>Stempel und Unterschrift</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="stamp.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (stamp.expanded) {
                <div class="p-6 pt-0 border-t border-app-primary-10/5">
                    <form [formGroup]="doctorSettingsForm" class="flex flex-col gap-10 mt-6">
                        <div class="flex flex-col gap-4">
                            <label class="text-app-primary-10 font-bold">Stempel</label>
                            @if (doctorSettingsForm.get('stamp')?.value == '' || doctorSettingsForm.get('stamp')?.value == undefined) {
                                <app-file-upload
                                    [maxFileSize]="200 * 1024"
                                    [allowedMimeTypes]="['image/png']"
                                    (fileSelected)="triggerFileUpload($event)"
                                    class="w-full">
                                </app-file-upload>
                            } @else {
                                <div
                                    class="relative group bg-white p-4 rounded-lg border border-app-primary-10/10 shadow-sm flex flex-col items-center">
                                    <img class="max-h-48 object-contain mb-4"
                                         [src]="'data:image/jpeg;base64,' + doctorSettingsForm.get('stamp')?.value">
                                </div>
                            }
                            <div class="flex gap-4 mt-2 justify-end">
                                <button class="btn secondary-button" (click)="clearStamp()">
                                    Stempel löschen
                                </button>
                            </div>
                        </div>
                        <div class="flex flex-col gap-4">
                            <label class="text-app-primary-10 font-bold">Unterschrift</label>
                            <div
                                class="bg-app-background-20 rounded-lg p-4 border border-app-primary-10/10 flex justify-center">
                                <signature-pad #signature [options]="signaturePadOptions"
                                               (drawEnd)="drawComplete()"></signature-pad>
                            </div>
                            <div class="flex gap-4 mt-2 justify-end">
                                <button class="btn secondary-button" (click)="clearSignature()">
                                    Unterschrift Löschen
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            }
        </div>
    </cdk-accordion-item>
</cdk-accordion>
<div class="flex justify-end mt-8">
    <button class="btn primary-button"
            (click)="submit()">
        <span>Speichern</span>
    </button>
</div>
